<template>
  <div>
    <el-card class="box-card" shadow="hover">
      <h2 slot="header">{{ $t('crm.retailStore') }}</h2>
      <div class="info-group">
        <div class="info-item">
          <label>{{ $t('crm.hasRetailStore') }}</label>
          <div class="value">{{ detail.isOfflineStore ? $t('crm.hasRetailStore1') : $t('crm.hasRetailStore0') }}</div>
        </div>
        <div class="info-item" v-if="detail.isOfflineStore">
          <label>{{ $t('crm.retailStoreScale') }}</label>
          <div class="value">{{ detail.offlineStoreDesc || '-' }}</div>
        </div>
      </div>
      <el-table class="mt20" :data="tableData" :header-cell-style="{backgroundColor: '#f0f0f0'}" border v-if="detail.isOfflineStore">
        <el-table-column :label="$t('crm.retailStore')">
          <template slot-scope="scope">
            {{ $t('crm.retailStore') }}{{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="storeName" :label="$t('crm.retailStoreName')"></el-table-column>
        <el-table-column prop="storeAddress" :label="$t('crm.retailStoreAddress')"></el-table-column>
        <el-table-column prop="storeSinceAt" :label="$t('crm.retailStoreYears')"></el-table-column>
        <el-table-column prop="saleAmountOfYear" :label="$t('crm.retailStoreAnnualSales')"></el-table-column>
        <el-table-column prop="percentage" :label="$t('crm.retailStoreSalesContribution')"></el-table-column>
      </el-table>
    </el-card>

    <el-card class="box-card" shadow="hover">
      <h2 slot="header">{{ $t('crm.otherSalesChannels') }}</h2>
      <div class="info-group">
        <div class="info-item full">
          <label>{{ $t('crm.hasEcWebsite') }}</label>
          <div class="value">{{ detail.official_status ? $t('common.yes') : $t('common.no') }}</div>
        </div>
      </div>
      <div class="info-group" v-if="detail.official_status">
        <div class="info-item">
          <label>{{ $t('crm.ecWebsite') }}{{ $t('crm.yearsOfOperatation') }}</label>
          <div class="value">{{ detail.official_sinceAt || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.ecWebsite') }}{{ $t('crm.annualSales') }}</label>
          <div class="value">{{ detail.official_saleAmount || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.ecWebsite') }}{{ $t('crm.salesContribution') }}</label>
          <div class="value">{{ detail.official_percentage || '-' }}</div>
        </div>
      </div>

      <div class="info-group mt20">
        <div class="info-item full">
          <label>{{ $t('crm.hasWholesaleBusiness') }}</label>
          <div class="value">{{ detail.wholesale_status ? $t('common.yes') : $t('common.no') }}</div>
        </div>
      </div>
      <div class="info-group" v-if="detail.wholesale_status">
        <div class="info-item">
          <label>{{ $t('crm.wholesaleBusiness') }}{{ $t('crm.yearsOfOperatation') }}</label>
          <div class="value">{{ detail.wholesale_sinceAt || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.wholesaleBusiness') }}{{ $t('crm.annualSales') }}</label>
          <div class="value">{{ detail.wholesale_saleAmount || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.wholesaleBusiness') }}{{ $t('crm.salesContribution') }}</label>
          <div class="value">{{ detail.wholesale_percentage || '-' }}</div>
        </div>
      </div>

      <div class="info-group mt20">
        <div class="info-item full">
          <label>{{ $t('crm.hasFarfetch') }}</label>
          <div class="value">{{ detail.farfetch_status ? $t('common.yes') : $t('common.no') }}</div>
        </div>
      </div>
      <div class="info-group" v-if="detail.farfetch_status">
        <div class="info-item">
          <label>{{ $t('crm.farfetch') }}{{ $t('crm.yearsOfOperatation') }}</label>
          <div class="value">{{ detail.farfetch_sinceAt || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.farfetch') }}{{ $t('crm.annualSales') }}</label>
          <div class="value">{{ detail.farfetch_saleAmount || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.farfetch') }}{{ $t('crm.salesContribution') }}</label>
          <div class="value">{{ detail.farfetch_percentage || '-' }}</div>
        </div>
      </div>

      <div class="info-group mt20">
        <div class="info-item full">
          <label>{{ $t('crm.hasDewu') }}</label>
          <div class="value">{{ detail.dw_status ? $t('common.yes') : $t('common.no') }}</div>
        </div>
      </div>
      <div class="info-group" v-if="detail.dw_status">
        <div class="info-item">
          <label>{{ $t('crm.dewu') }}{{ $t('crm.yearsOfOperatation') }}</label>
          <div class="value">{{ detail.dw_sinceAt || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.dewu') }}{{ $t('crm.annualSales') }}</label>
          <div class="value">{{ detail.dw_saleAmount || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.dewu') }}{{ $t('crm.salesContribution') }}</label>
          <div class="value">{{ detail.dw_percentage || '-' }}</div>
        </div>
      </div>

      <div class="info-group mt20">
        <div class="info-item">
          <label>{{ $t('crm.otherSalesChannels2') }}</label>
          <div class="value">{{ detail.otherChannel || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.sourceOfGoods') }}</label>
          <div class="value">{{ detail.stockChannel || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.mpProfitExpectation') }}</label>
          <div class="value">{{ detail.mpProfitExpectation || '-' }}</div>
        </div>
        <div class="info-item">
          <label>{{ $t('crm.profitExpectation') }}</label>
          <div class="value">{{ detail.pfProfitExpectation || '-' }}</div>
        </div>
      </div>
    </el-card>

  </div>
</template>

<script>
import {
  getVendorOfflineStoreList,
  getVendorChannelList,
  getVendorExtInfo,
} from '../api';

export default {
  data() {
    return {
      detail: {},
      tableData: [],
    };
  },
  mounted() {
    getVendorOfflineStoreList({
      vendorId: this.$route.params.id,
    }).then((res) => {
      if (res.data.success && res.data.data) {
        this.tableData = res.data.data;
      }
    });
    getVendorChannelList({
      vendorId: this.$route.params.id,
    }).then((res) => {
      if (res.data.success && res.data.data) {
        this.detail = {
          ...this.detail,
          ...res.data.data,
        };
      }
    });
    getVendorExtInfo({
      vendorId: this.$route.params.id,
    }).then((res) => {
      if (res.data.success && res.data.data) {
        this.detail = {
          ...this.detail,
          ...res.data.data,
        };
      }
    });
  },
}
</script>

<style lang="less" scoped>
.mt10 {
  margin-top: 10px;
}
.mt20 {
  margin-top: 20px;
}
.box-card {
  margin-bottom: 20px;
}
.info-group {
  display: flex;
  flex-wrap: wrap;
}
.info-item {
  display: flex;
  width: 50%;
  line-height: 20px;

  label {
    flex: 0 0 auto;
    width: 200px;
    padding: 10px;
    background-color: #f9f9f9;
    border: 1px solid #EBEEF5;
  }
  .value {
    flex: 1;
    padding: 10px;
    border-top: 1px solid #EBEEF5;
    border-right: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
  }

  &:nth-child(even) {
    label {
      border-left: 0;
    }
  }
  &:nth-child(n+3) {
    label {
      border-top: 0;
    }
    .value {
      border-top: 0;
    }
  }
  &.full {
    width: 100%;

    label {
      border-bottom: 0;
    }
    .value {
      border-bottom: 0;
    }
  }
}
</style>